import { render, staticRenderFns } from "./SimWifi.vue?vue&type=template&id=dd80648a&"
import script from "./SimWifi.vue?vue&type=script&lang=js&"
export * from "./SimWifi.vue?vue&type=script&lang=js&"
import style0 from "./SimWifi.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports